export default "__VITE_ASSET__83c143a7__"